import { get } from 'lodash';
import { put, select, takeLeading } from 'redux-saga/effects';
import { callApi } from 'helpers/saga-helpers';
import { requestClaimRecap } from 'containers/RecapManagerPage/actions';
import { makeSelectKeycloakToken } from 'containers/AppContainer/selectors';
import {
  FIND_PROVISIONAL_CLAIM_BY_REFERENCE,
  REQUEST_UPDATE_CLAIM,
  REQUEST_UPDATE_FRAUD_INFO,
} from 'containers/PreOpeningPage/constants';
import accessTokenStorage from 'containers/services/security/access-token-storage';
import { setIsProvisionalClaimExist } from 'containers/PreOpeningPage/actions';
import currentIntervenantStorage from 'containers/services/security/current-intervenant-storage';

export function* updateClaim(action: any): Generator<unknown> {
  const { claimRecap, successCallback } = action;
  const path = `/corporeal/common/change-claim`;

  let token = yield select(makeSelectKeycloakToken());

  if (!token) token = accessTokenStorage.get().token;

  if (!token) return;

  const options = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      claimRecap,
      isLawyer: get(claimRecap, 'isLawyer'),
    }),
  };

  const errorResponse = yield callApi(path, {}, options, []);

  if (!errorResponse) {
    yield successCallback();
    yield put(requestClaimRecap(get(claimRecap, 'claim.id')));
  }
}

export function* updateClaimSaga() {
  yield takeLeading(REQUEST_UPDATE_CLAIM, updateClaim);
}
export function* updateFraudInfo(action: any): Generator<unknown> {
  const { payload, successCallback } = action;
  const path = `/corporeal/fraud-info`;

  const token = accessTokenStorage.get().token;
  if (!token) return;

  const options = {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      ...payload,
    }),
  };

  const errorResponse = yield callApi(path, {}, options, []);

  if (!errorResponse) {
    yield successCallback();
    yield put(requestClaimRecap(Number(get(payload, 'claimId'))));
  }
}

export function* updateFraudInfoSaga() {
  yield takeLeading(REQUEST_UPDATE_FRAUD_INFO, updateFraudInfo);
}

export function* findProvisionalClaimByReference(
  action: any,
): Generator<unknown> {
  const { reference, successCallback } = action;
  const path = !!currentIntervenantStorage.get()
    ? `/corporeal/provisional-claim/find-by-reference/${reference}?isIntervenant=true`
    : `/corporeal/provisional-claim/find-by-reference/${reference}`;

  const token = !!currentIntervenantStorage.get()
    ? yield select(makeSelectKeycloakToken())
    : accessTokenStorage.get().token;
  if (!token) return;

  const options = {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };

  const errorResponse = yield callApi(
    path,
    {},
    options,
    [],
    setIsProvisionalClaimExist,
  );
  if (!errorResponse) {
    yield successCallback();
  }
}

export function* findProvisionalClaimByReferenceSaga() {
  yield takeLeading(
    FIND_PROVISIONAL_CLAIM_BY_REFERENCE,
    findProvisionalClaimByReference,
  );
}

export default [
  updateClaimSaga,
  updateFraudInfoSaga,
  findProvisionalClaimByReferenceSaga,
];
